// photo-organizer 에이전트 로컬 컴포넌트 라이브 샘플 — 실제 컴포넌트를 딥 경로로 import 해 목 데이터로 렌더한다.
// 갤러리는 apiClient 요청을 차단하므로 ThumbImg 를 쓰는 컴포넌트의 사진은 fallback(빈 칸)으로 보인다(의도).
import { useState, type ReactNode } from 'react';
import { Button } from '@indipia/ui-core';
import type { CompanyMember } from '@indipia/shared-features';
import { ThumbImg } from '@indipia/agents-photo-organizer/src/components/ThumbImg';
import { PhotoViewerLayer } from '@indipia/agents-photo-organizer/src/components/PhotoViewerLayer';
import { highlight } from '@indipia/agents-photo-organizer/src/components/Highlight';
import { PhotoCard } from '@indipia/agents-photo-organizer/src/components/PhotoCard';
import { SearchBar } from '@indipia/agents-photo-organizer/src/components/SearchBar';
import { AssigneeFilterField } from '@indipia/agents-photo-organizer/src/components/AssigneeFilterField';

const FAKE_URL = '/photo/thumb/demo-1.jpg';
const SPACES = ['욕실', '주방', '거실'];

const VIEWER_PHOTOS = SPACES.map((space, i) => ({
  photoId: i + 1,
  thumbUrl: `/photo/thumb/demo-${i + 1}.jpg`,
  originalUrl: `/photo/original/demo-${i + 1}.jpg`,
  takenAt: `2026-10-1${i + 1}`,
  registeredAt: '2026-10-15',
  tags: [
    { tagType: 'SPACE', tagValue: space },
    { tagType: 'WORK', tagValue: '타일' },
  ],
}));

const MEMBERS: CompanyMember[] = [
  { memberId: 1, memberName: '김대표', roleCode: 'OWNER' },
  { memberId: 2, memberName: '이반장', roleCode: 'STAFF' },
  { memberId: 3, memberName: '박실장', roleCode: 'STAFF' },
];

const noop = () => {};

function PhotoViewerLayerDemo() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button size="sm" onClick={() => setOpen(true)}>
        열기
      </Button>
      {open && (
        <PhotoViewerLayer photos={VIEWER_PHOTOS} initialIndex={0} sitePhotoCount={3} onClose={() => setOpen(false)} />
      )}
    </>
  );
}

function PhotoCardDemo() {
  const [checked, setChecked] = useState(true);
  const [tags, setTags] = useState(['욕실', '타일', '시공후']);
  const [removed, setRemoved] = useState(true);
  return (
    <div className="grid grid-cols-2 gap-3">
      <PhotoCard
        photoId={1}
        thumbUrl={FAKE_URL}
        takenAt="2026-10-12"
        registeredAt="2026-10-15"
        tags={tags}
        newTags={['시공후']}
        checked={checked}
        onToggle={() => setChecked((c) => !c)}
        onViewPhoto={noop}
        onAddTag={(t) => setTags((ts) => [...ts, t])}
        onRemoveTag={(t) => setTags((ts) => ts.filter((x) => x !== t))}
      />
      <PhotoCard
        photoId={2}
        thumbUrl={FAKE_URL}
        takenAt="2026-10-11"
        registeredAt="2026-10-15"
        tags={['주방']}
        showCheckbox={false}
        removed={removed}
        onRemove={() => setRemoved((r) => !r)}
      />
    </div>
  );
}

function AssigneeFilterFieldDemo() {
  const [values, setValues] = useState<number[]>([2]);
  return <AssigneeFilterField members={MEMBERS} values={values} onChange={setValues} myId={1} />;
}

export const demos: Record<string, () => ReactNode> = {
  ThumbImg: () => (
    <div className="flex flex-col gap-2">
      <ThumbImg
        url={FAKE_URL}
        className="h-24 w-32 rounded-md object-cover"
        fallback={
          <div className="flex h-24 w-32 items-center justify-center rounded-md bg-surface-muted text-caption text-text-muted">
            fallback
          </div>
        }
      />
      <p className="text-caption text-text-secondary">API 차단 상태 → fallback</p>
    </div>
  ),
  PhotoViewerLayer: () => <PhotoViewerLayerDemo />,
  highlight: () => <p>{highlight('강남 리모델링 욕실 타일 시공', ['욕실', '타일'])}</p>,
  PhotoCard: () => <PhotoCardDemo />,
  SearchBar: () => (
    <SearchBar onSearch={noop} enableStatusFilter statusCounts={{ total: 24, ACTIVE: 8, PROGRESS: 11, DONE: 5 }} />
  ),
  AssigneeFilterField: () => <AssigneeFilterFieldDemo />,
};
